import { Container } from "reactstrap";

const LoadingSpinner = ({ message = "Loading..." }) => {
    return (
        <Container className="mt--7" fluid>
            <div className="text-center py-4">
                <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
                <p className="mt-2">{message}</p>
            </div>
        </Container>
    );
};

export default LoadingSpinner;
